"use client";

import { CtaArrow } from "@/components/editorial/cta-arrow";

import { useState } from "react";
import { TwinMark } from "@product/components/app/twin/twin-mark";
import styles from "./customer-answer.module.css";

import { NORTHSTAR_ANSWER, type StoryAnswer } from "./answer-content";

export function CustomerAnswer({ compact = false, answer = NORTHSTAR_ANSWER }: { compact?: boolean; answer?: StoryAnswer }) {
  const [selected, setSelected] = useState(0);
  const record = answer.records[selected]!;
  return <div className={styles.panel} data-compact={compact}>
    {!compact && <div className={styles.identity}><TwinMark /><span>YOUR BUSINESS TWIN</span><span>Example</span></div>}
    <h3>{answer.question}</h3>
    <p>{answer.parts.map((part, index) => part.source === undefined ? part.text : <button key={index} aria-pressed={selected === part.source} onClick={() => setSelected(part.source!)}>{part.text}</button>)}</p>
    <div className={styles.tabs} aria-label={`${answer.entity} source records`}>
      {answer.records.map((item, i) => <button key={item.name} aria-pressed={selected === i} onClick={() => setSelected(i)}>{item.name}<span><CtaArrow /></span></button>)}
    </div>
    <div className={styles.record} aria-live="polite" aria-atomic="true">
      <span>{record.system}</span><h4>{record.title}</h4><strong>{record.value}</strong><p>{record.detail}</p>
    </div>
    <small>Illustrative records · Select a fact to inspect its source</small>
  </div>;
}
